<script setup>
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import AppBar from './components/AppBar.vue'
import NavDrawer from './components/NavDrawer.vue'
import ConsentBanner from './components/ConsentBanner.vue'
import BackToTop from './components/BackToTop.vue'
import { useTheme } from './composables/useTheme.js'

const route = useRoute()

// weather vertical owns the global AppBar; Discover/Article bring their own top bars
const isWeatherRoute = computed(() => !['feed', 'article'].includes(route.name))
// 文档页（隐私/条款/关于）不需要温度单位切换
const showUnit = computed(() => isWeatherRoute.value && !['privacy', 'terms', 'about'].includes(route.name))

// 全站背景：根据当前天气 condition.code 切换渐变主题
// （useTheme 内部已 watch + immediate，这里调用一次即完成挂载）
useTheme()
</script>

<template>
  <div class="app">
    <!-- 全站背景：按当前天气切换的渐变（useTheme 推 --bg-gradient） -->
    <div class="app__bg" aria-hidden="true" />
    <!-- 薄纱：深色底压暗顶部、浅色底提亮顶部，保证文字与 10% 白玻璃的对比度 -->
    <div class="app__veil" aria-hidden="true" />

    <AppBar
      v-if="isWeatherRoute"
      :title="$t(route.meta?.titleKey || 'app.title')"
      :show-unit-toggle="showUnit"
    />
    <NavDrawer />
    <main class="app__main">
      <RouterView />
    </main>
    <BackToTop />
    <ConsentBanner />
  </div>
</template>

<style>
.app { min-height: 100vh; display: flex; flex-direction: column; position: relative; }
/* 背景交给两个固定层，.app 自身必须透明，否则会盖住负 z-index 的固定层 */
.app__bg {
  position: fixed; inset: 0; z-index: -3;
  background: var(--bg-gradient);
  transition: background var(--d-med) var(--ease-out);
}
.app__veil {
  position: fixed; inset: 0; z-index: -2; pointer-events: none;
  background: var(--bg-veil);
}
.app__main { flex: 1; padding-bottom: var(--safe-bottom); }
</style>
